var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Action, Actions, Selector, State, Store } from '@ngxs/store';
import { HistoryToolService } from '../../../image-editor/history/history-tool.service';
import { CloseForePanel, OpenPanel } from '../../../image-editor/state/editor-state-actions';
import { HistoryNames } from '../../../image-editor/history/history-names.enum';
import { ShapesToolService } from '../../../image-editor/tools/shapes/shapes-tool.service';
import { AddShape } from './shapes.actions';
import { BaseToolState } from '../base-tool.state';
import { DrawerName } from '../../toolbar-controls/drawers/drawer-name.enum';
var ShapesState = /** @class */ (function (_super) {
    __extends(ShapesState, _super);
    function ShapesState(store, shapesTool, history, actions$) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.shapesTool = shapesTool;
        _this.history = history;
        _this.actions$ = actions$;
        _this.toolName = DrawerName.SHAPES;
        return _this;
    }
    ShapesState.dirty = function (state) {
        return state.dirty;
    };
    ShapesState.prototype.applyChanges = function (ctx) {
        this.store.dispatch(new OpenPanel(DrawerName.OBJECT_SETTINGS));
        if (ctx.getState().dirty) {
            this.history.add(HistoryNames.SHAPES);
        }
        ctx.patchState({ dirty: false });
    };
    ShapesState.prototype.cancelChanges = function (ctx) {
        this.store.dispatch(new CloseForePanel());
        if (ctx.getState().dirty) {
            this.history.reload();
        }
        ctx.patchState({ dirty: false });
    };
    ShapesState.prototype.addShape = function (ctx, action) {
        ctx.patchState({ dirty: true });
        this.shapesTool.addBasicShape(action.shape);
    };
    __decorate([
        Action(AddShape),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, AddShape]),
        __metadata("design:returntype", void 0)
    ], ShapesState.prototype, "addShape", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShapesState, "dirty", null);
    ShapesState = __decorate([
        State({
            name: 'shapes',
            defaults: {
                dirty: false,
            }
        }),
        __metadata("design:paramtypes", [Store,
            ShapesToolService,
            HistoryToolService,
            Actions])
    ], ShapesState);
    return ShapesState;
}(BaseToolState));
export { ShapesState };
